export const generateInitials = (data: string[]) =>
  data
    .map((text) =>
      text
        .split(' ')
        .map((str) => str[0])
        .join(''),
    )
    .join('');
